import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";
import { Button } from "./ui/button";

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event("fasnet-install-ready")); });

export function InstallAppCard() {
  const [ready, setReady] = useState(!!deferredPrompt);
  const [ios, setIos] = useState(false);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem("install_card_hidden") === "1");
  const [guide, setGuide] = useState(false);
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("fasnet-install-ready", on);
    window.addEventListener("appinstalled", () => setHidden(true));
    return () => window.removeEventListener("fasnet-install-ready", on);
  }, []);
  if (hidden) return null;
  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") setHidden(true);
      deferredPrompt = null; setReady(false);
    } else { setIos(isIos()); setGuide(true); }
  };
  const dismiss = () => { localStorage.setItem("install_card_hidden", "1"); setHidden(true); };
  return (
    <div className="rounded-2xl border border-[#F04E23]/40 bg-gradient-to-r from-[#0B1E33] to-[#15314f] text-white p-3 flex items-center gap-3" data-testid="install-app-card">
      <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold">Pasang Aplikasi Fasnet Fiber</div>
        <div className="text-[11px] text-white/70">Buka lebih cepat dari layar utama HP, tanpa ketik alamat.</div>
        {guide && (
          <div className="mt-2 rounded-lg bg-white/10 p-2 text-[11px] space-y-1" data-testid="install-guide">
            {ios ? (<>
              <div>1. Ketuk tombol <b>Bagikan</b> <Share className="inline w-3 h-3" /> di bawah layar Safari.</div>
              <div>2. Pilih <b>Tambah ke Layar Utama</b> <SquarePlus className="inline w-3 h-3" />.</div>
              <div>3. Ketuk <b>Tambah</b>. Ikon Fasnet Fiber muncul di layar utama.</div>
            </>) : (<>
              <div>1. Ketuk menu <b>⋮</b> di pojok kanan atas browser (Chrome).</div>
              <div>2. Pilih <b>Tambahkan ke layar utama</b> / <b>Instal aplikasi</b>.</div>
              <div>3. Ketuk <b>Tambah</b>. Ikon Fasnet Fiber muncul di layar utama.</div>
            </>)}
          </div>
        )}
      </div>
      <div className="flex flex-col items-end gap-1 shrink-0">
        <Button size="sm" className="h-8 bg-[#F04E23] hover:bg-[#d8431c] text-white" onClick={install} data-testid="install-app-btn"><Download className="w-4 h-4 mr-1" /> {ready ? "Pasang" : guide ? "Cara Pasang" : "Pasang"}</Button>
        <button type="button" onClick={dismiss} className="text-[10px] text-white/50 hover:text-white inline-flex items-center gap-0.5" data-testid="install-app-dismiss"><X className="w-3 h-3" /> nanti</button>
      </div>
    </div>
  );
}
